<template>
    <Link :href="link">
        <AppCard>
            <img v-if="image || !video" :src="image ?? '/images/misc/default_news.jpg'"
                 height="200"
                 class="w-full rounded-lg aspect-video object-cover">

            <AppVideo v-else
                      thumbnail-only
                      :type="video.type"
                      :clip="video.video_id"
            ></AppVideo>


            <p class="text-dark mt-2">{{ postDate }}</p>

            <h3 class="text-lg font-bold text-black mt-4">{{ title }}</h3>

            <p class="mt-4 text-black" v-html="excerpt"></p>

            <AppButton v-if="link" class="mt-4" :href="link">Read more</AppButton>
        </AppCard>
    </Link>
</template>

<script setup>
import AppCard from "@/Components/AppCard";
import AppVideo from "@/Components/AppVideo";
import {computed} from "vue";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import AppButton from "@/Components/AppButton";
import {Link} from "@inertiajs/inertia-vue3";

dayjs.extend(advancedFormat);

const props = defineProps({
    date: String,
    title: String,
    excerpt: String,
    link: String,
    video: String,
    image: String
});

const postDate = computed(() => dayjs(props.date).format("Do MMMM YYYY"));
</script>

<style scoped>

</style>
